module.exports = __webpack_public_path__ + "img/jaime.c__600x600.00cd335b.jpg";